import type {ApiError} from 'shared/web';

/**
 * What `.unwrap()` rejects with: a `FetchBaseQueryError` or a `SerializedError`, both plain objects.
 * A thrown `Error` (a `TypeError` in the save flow) is a bug, not a rejected request.
 */
export const isApiError = (error: unknown): error is ApiError =>
  typeof error === 'object' && error !== null && !(error instanceof Error);
